export interface I18nSettingsModel {
  defaultLanguage?: string | null;
  hideLanguageSwitcher?: boolean;
}
